import { StudentData } from '@nrdy-marketing-engine/cart/@types/student-data';
import { UserSubscription } from '@nrdy-marketing-engine/cart/@types/user-subscription';

export function subscriptionsHaveTutoringHours(userSubscriptions: UserSubscription[]) {
  return userSubscriptions?.some(({ entitlements }) => {
    const tutoringHoursEntitlement = entitlements?.find(({ type }) => type === 'tutoring_hours');
    const number_of_hours = tutoringHoursEntitlement?.configuration?.number_of_hours;

    return number_of_hours > 0;
  });
}

export function hasTutor(students: StudentData[]) {
  if (!students) return false;
  return Boolean(
    students?.find((student) => student?.has_active_assignment || student?.has_active_placement)
  );
}
